
export const clearAllAlerts = () => {
    return {
        type: 'CLEAR_ALL_ALERTS'
    }
};

export const clearAllNotStickyAlerts = () => {
    return {
        type: 'CLEAR_ALL_NOT_STICKY_ALERTS'
    }
}

export const removeAlert = (id) => {
    return {
        type: 'REMOVE_ALERT',
        id
    }
};

export const addAlert = (data) => {
    return {
        type: 'ADD_ALERT',
        data
    }
};




